@if (mainFilename$ | async; as mainFilename) {
  <thh-hund-angebot
    *axLazyElement="'thh-hund-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></thh-hund-angebot>
}
